import { useTranslation } from "@redotech/redo-i18n";
import DotsVerticalIcon from "@redotech/redo-icons/dots-vertical.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import {
  RedoCommandMenu,
  type RedoCommandMenuItem,
} from "@redotech/redo-web/arbiter-components/command-menu/redo-command-menu";
import { memo, useState, type MouseEvent } from "react";

/** Kebab menu holding a saved payment method's actions. */
export const PaymentMethodActionsMenu = memo(function PaymentMethodActionsMenu({
  disabled,
  items,
  pending,
}: {
  disabled?: boolean;
  items: RedoCommandMenuItem[];
  pending?: boolean;
}) {
  const { t } = useTranslation();
  const [anchor, setAnchor] = useState<HTMLButtonElement | null>(null);
  const [open, setOpen] = useState(false);

  const closingItems = items.map((item) => ({
    ...item,
    onClick: (event: MouseEvent<HTMLButtonElement>) => {
      setOpen(false);
      item.onClick?.(event);
    },
  }));

  return (
    <>
      <RedoButton
        aria-label={t("Payment method actions")}
        disabled={disabled}
        hierarchy="tertiary"
        IconLeading={DotsVerticalIcon}
        onClick={() => setOpen((current) => !current)}
        pending={pending}
        ref={setAnchor}
        size="sm"
      />
      <RedoCommandMenu
        anchor={anchor}
        items={closingItems}
        open={open}
        setOpen={setOpen}
        size="sm"
      />
    </>
  );
});
